import type { ComponentProps } from 'react';
import { TextInput } from 'is24-corecss';
import { useFormContext, useFormState } from 'react-hook-form';
import type { RegisterOptions } from 'react-hook-form';

type FormInputProps = Omit<
  ComponentProps<typeof TextInput.Input>,
  'name' | 'ref' | 'value' | 'defaultValue' | 'onChange' | 'onBlur'
> & {
  name: string;
  label: string;
  rules?: RegisterOptions;
};

export const FormInput = ({ name, label, rules, id, className, required, disabled, ...inputProps }: FormInputProps) => {
  const { register, getFieldState, control } = useFormContext();
  const formState = useFormState({ control, name, exact: true });
  const { invalid, error } = getFieldState(name, formState);

  return (
    <TextInput.Root
      id={id}
      className={className}
      required={required ?? !!rules?.required}
      disabled={disabled}
      invalid={invalid}
    >
      <TextInput.Label>{label}</TextInput.Label>
      <TextInput.Input {...inputProps} {...register(name, rules)} />
      <TextInput.ErrorText role='alert'>{error?.message}</TextInput.ErrorText>
    </TextInput.Root>
  );
};
